import { Button } from './ui/button';
import { isDebugMode, generateRandomFormData } from '../utils/debug';
import { useState } from 'react';
import { t } from '../locales/nl';

interface DebugButtonProps {
  fields: any[];
  onFill: (_data: Record<string, any>) => void;
}

export const DebugButton = ({ fields, onFill }: DebugButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!isDebugMode()) {
    return null;
  }

  const handleDebugFill = async () => {
    try {
      setIsLoading(true);
      const randomData = await generateRandomFormData(fields);
      onFill(randomData);
    } catch (error) {
      console.error('Error generating debug data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleDebugFill}
      disabled={isLoading}
      className="fixed bottom-4 right-4 z-50 bg-yellow-400 hover:bg-yellow-500"
    >
      {isLoading ? t.sending : t.debugFillForm}
    </Button>
  );
}; 